import Filter2 from "../../components/CRUD/Filter2";
import { getDepartments, getDivisions, getFilials } from "../../redux/actions";
import { getFilialDivisions } from "../../redux/actions/filialDivisionActions";
import { getPurposeOfSelections } from "../../redux/actions/purposeOfSelectionActions";

const Ses18Filter = ({query, setQuery}) => {
    const filterFields = [        
        {
            title: "Отчетный месяц с",
            key: "researchEndDateTime",
            operandPosition: 1,
            compareType: "between",
            type: "date2",
            filterType: "normal",
        },
        {
            title: "Отчетный месяц по",
            key: "researchEndDateTime",
            operandPosition: 2,
            compareType: "between",
            type: "date2",
            filterType: "normal",
        },
        {
            title: "Филиал",
            key: "filialId",
            compareType: "equals",
            reducerKey: "filial",
            reducerArrayKey: "filials",
            reducerAction: getFilials,
            filter: (opt) => {
                let result = true;

                if (opt.id == null) {
                return true;
                }

                return result;
            },
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
        {
            title: "Районное отделение",
            key: "filialDivisionId",
            compareType: "equals",
            reducerKey: "filialDivision",
            reducerArrayKey: "filialDivisions",
            reducerAction: getFilialDivisions,
            operandPosition: 1,
            parentKey: 'filialId',
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
        {
            title: "Лаборатория",
            key: "departmentId",
            compareType: "equals",
            reducerKey: "department",
            reducerArrayKey: "departments",
            reducerAction: getDepartments,
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
        {
            title: "Отдел",
            key: "divisionId",
            compareType: "equals",
            reducerKey: "division",
            reducerArrayKey: "divisions",
            reducerAction: getDivisions,
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },                
        {
            title: "Цель отбора",
            key: "referral",
            key1: "referral",
            key2: "purposeOfSelectionId",
            compareType: "equals",
            reducerKey: "purposeOfSelection",
            reducerArrayKey: "purposeOfSelections",
            reducerAction: getPurposeOfSelections,
            operandPosition: 1,
            optionLabelKey: "name",
            type: "normal",
            filterType: "normal",
        },
    ];

    return <Filter2 filter={query.filter} setFilter={_ => {
        setQuery({...query, filter: {
            ...query.filter,
            ..._
        }});
    }}
    filterFields={filterFields}
    />

}

export default Ses18Filter;